export function displayTimeZone(s: string) {
  return `${s} (${new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
  })
    .format(new Date())
    .split(' ')
    .pop()})`;
}
